import { __decorate } from "tslib";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { NgxsModule } from '@ngxs/store';
import { MaintenanceAnnouncementComponent } from './components/maintenance-announcement.component';
import { MaintenanceModeComponent } from './components/maintenance-mode.component';
import { MaintenanceModeInterceptor } from './interceptor/maintenance-mode.interceptor';
import { MaintenanceState } from './state/maintenance.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
let MaintenanceFrontendFeature = /*#__PURE__*/(() => {
  let MaintenanceFrontendFeature = class MaintenanceFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/maintenance/frontend","featureId":"common-maintenance"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: MaintenanceAnnouncementComponent,
        excludeSSR: true
      }, {
        component: MaintenanceModeComponent,
        excludeSSR: true
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMaintenanceFrontendFeature_BaseFactory;
        return function MaintenanceFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMaintenanceFrontendFeature_BaseFactory || (ɵMaintenanceFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MaintenanceFrontendFeature)))(__ngFactoryType__ || MaintenanceFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MaintenanceFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: MaintenanceModeInterceptor
        }],
        imports: [NgxsModule.forFeature([MaintenanceState]), MaintenanceAnnouncementComponent, MaintenanceModeComponent]
      });
    }
  };
  MaintenanceFrontendFeature = __decorate([ClassName("MaintenanceFrontendFeature")], MaintenanceFrontendFeature);
  return MaintenanceFrontendFeature;
})();
export { MaintenanceFrontendFeature };